import React from "react";
import Menu from "./menu/Menu";
import { Container } from "react-bootstrap";
import './Layout.css';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    return (<>
        <Container fluid className="px-0">
            <Menu />
            <div className="px-2 pt-2 pb-5">{children}</div>
        </Container>
    </>);
}

export default Layout;